module.exports = __webpack_public_path__ + "img/0053.4a31b7c1.gif";